import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {toJS} from "mobx";

import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
import Button from "../../components/CustomButtons/Button.jsx";
import IconCard from "../../components/Cards/IconCard";

import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import EventNoteIcon from '@material-ui/icons/EventNote';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
import Cookies from "universal-cookie";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CancelRoundedIcon from "@material-ui/icons/Cancel";
import {EXCEL_CALENDARIO_FILENAME} from "../../utils/constants";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import IconButton from "material-ui/IconButton";
import Close from "@material-ui/icons/Close";


import withStyles from "material-ui/styles/withStyles";
import notificationsStyle from '../../assets/jss/material-dashboard-pro-react/views/notificationsStyle';
import SweetAlert from "react-bootstrap-sweetalert";

import '../../assets/css/calendar-management.css';

const cookies = new Cookies();


@inject('store')
@observer
class CalendarManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            calendar_selected: false,
            edit_mode_is_active: false,
            calendar_name: '',
            calendar: {},
            calendar_data: [],
            selected_calendar: '',
            id_calendar_to_be_deleted: null,
            selected_calendar_data: [],
            fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            fileExtension: '.xlsx',
            error_update_calendar: false,
            calendar_updated_ok: false,
            error_calendar_data: false,
            errors: {},
            calendars_data_exists: true
        }
        this.store = this.props.store.appState;
    }

    componentDidMount() {
        this.getCalendars();
        this.store.clearCalendarData();
    }

    selectCalendar = (event) => {
        let self = this;
        const idCalendar = event.target.value;
        const project_id = cookies.get('project_id');
        const data = {idProject: project_id, idCalendar: idCalendar};

        self.store.getCalendarData(data, function (res) {
            if (res && res.length > 0) {
                self.store.selected_calendar_id = event.target.value;
                self.store.selected_calendar_data = res;
                self.store.selected_calendar_name = res[0].calendar_name;
                self.store.calendar_selected = true;
            }else {
                self.setState({
                    error_calendar_data: true
                })
            }
        });
    }

    deleteCalendarConfirmed = () => {
        // const self = this;
        const id_calendar = this.state.id_calendar_to_be_deleted;
        const project_id = cookies.get('project_id');

        const data = {
            id_project: project_id,
            id_calendar: id_calendar
        }
        
        // self.store.delete_calendar_by_id(data, function(res){
        //     this.setState({
        //         show_delete_calendar_alert: false
        //     });
        // });

        this.setState({
            show_delete_calendar_alert: false
        });
    }

    initDeleteCalendar = (calendar) => {
        this.setState({
            show_delete_calendar_alert: true,
            id_calendar_to_be_deleted: calendar.id
        });
    }

    handleModalClose = () => {
        this.setState({
            edit_mode_is_active: false
        });
    }

    editCalendar = (calendar) => {
        this.setState({
            calendar: calendar,
            edit_mode_is_active: true
        })
    }

    getCalendars = () => {
        const self = this;
        const project_id = cookies.get('project_id');
        const data = {idProject: project_id};

        self.store.getCalendars(data, function (res) {
            if (res && res.length > 0) {
                self.setState({calendar_data: res});
            } else {
                self.setState({
                    calendars_data_exists: false
                })
            }
        });
    }

    closeDeleteCalendarAlert = () => {
        this.setState({
            show_delete_calendar_alert: false
        });
    }

    downloadCalendarData = () => {
        const {selected_calendar_data} = this.store;
        let exportData = [];
        selected_calendar_data.map((item) => {
            let obj = {
                "Project Id": this.store.project_id,
                "Calendar Id": item.calendar_id,
                'Nome Calendario': item.calendar_name,
                'Type': item.type,
                'Month': item.month,
                'Title': item.title,
                'Description': item.description,
                "Path":item.s3_path

            };
            return exportData.push(obj);
        });

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: this.state.fileType});

        const d = new Date();
        const currentDayOfMonth = d.getDate();
        const currentMonth = d.getMonth();
        const currentYear = d.getFullYear();
        const dateString = currentDayOfMonth + "-" + (currentMonth + 1) + "-" + currentYear;
        FileSaver.saveAs(data, EXCEL_CALENDARIO_FILENAME + '-' + dateString + this.state.fileExtension);
    }

    closeTable = () => {
        const self = this;
        self.store.calendar_selected = false;
        self.store.selected_calendar_data = [];
        self.store.selected_calendar_id = '';
    }

    handleEditCalendarData = () => {
        const self = this;
        const {calendar} = this.state;

        const data = {
            ...calendar,
            calendar_id: Number(self.store.selected_calendar_id),
            project_id: Number(cookies.get('project_id'))
        }

        if (!calendar.title.trim()) {
            self.setState({
                errors: {
                    ...this.state.errors,
                    title: true
                }
            })
            return;
        }

        if (!calendar.description.trim()) {
            self.setState({
                errors: {
                    ...this.state.errors,
                    description: true
                }
            })
            return;
        }

        this.store.saveEditedCalendarData(data, function (res) {
            if (res) {
                self.setState({
                    calendar_updated_ok: true,
                    edit_mode_is_active: false

                })
                const calendar_data = {idProject: self.store.project_id, idCalendar: self.store.selected_calendar_id}
                self.store.getCalendarData(calendar_data, function (res) {
                    if (res && res.length > 0) {
                        self.store.selected_calendar_data = res;
                    }
                });
            } else {
                self.setState({
                    error_update_calendar: true
                })
            }
        });
    }
    render() {
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        const project_id = cookies.get('project_id');
        const project_name = cookies.get('project_name');
        const {classes} = this.props;
        const {calendar_data, edit_mode_is_active, show_delete_calendar_alert, calendar, error_update_calendar, calendar_updated_ok, errors, error_calendar_data, calendars_data_exists} = this.state;

        // const nome_calendario = calendar_data[0].calendar_name;
        // console.log("CALENDAR", nome_calendario);

        return (
            <React.Fragment>
                <GridContainer justify='center'>
                    <ItemGrid xs={10} sm={10} md={10}><h2
                        style={{textAlign: "center"}}>{project_id} - {project_name}</h2></ItemGrid>
                    <ItemGrid xs={6} sm={6} md={6}>
                        <div id='select-calendar-button' style={{display: 'flex', justifyContent: 'center'}}>
                            <Button
                                style={{width: '218px', height: '2.5rem'}}
                                color={(this.store.calendar_selected || !calendars_data_exists) ? 'primary' : 'purple'}
                                size='sm'
                                disabled={this.store.calendar_selected || !calendars_data_exists}
                                round>
                                <Select
                                    displayEmpty
                                    renderValue={
                                        this.store.calendar_selected
                                            ? null
                                            : () => <p
                                                className={'select_calendar'}>{DEFAULT_TEXT.select_calendar.toUpperCase()}</p>
                                    }
                                    fullWidth={true}
                                    onChange={(event) => this.selectCalendar(event)}
                                    value={this.store.selected_calendar_id}
                                    style={{color: "white"}}
                                    disableUnderline={true}
                                    inputProps={{
                                        name: "simpleSelect",
                                        id: "calendar-select"
                                    }}>
                                    {
                                        calendar_data.map((calendar, key) => {
                                            return (
                                                <MenuItem key={key} value={calendar.id}>
                                                    <span className='span-lang'>{calendar.name}</span>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Button>
                        </div>
                    </ItemGrid>
                    {
                        this.store.calendar_selected &&
                        <ItemGrid xs={10} sm={10} md={10}>
                            <IconCard
                                icon={EventNoteIcon}
                                iconColor="rose"
                                title={this.store.selected_calendar_name.toUpperCase()}
                                // title={calendar_data[0].calendar_name.toUpperCase()}
                                content={
                                    <div>
                                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                            <div style={{marginRight: '20px'}}>
                                                <div className='tooltip'>
                                                    <span className="tooltipTextCalendar">Download data</span>
                                                    <CloudDownloadIcon className='download-cal-icon' onClick={this.downloadCalendarData}/>
                                                </div>
                                            </div>
                                            <CancelRoundedIcon className='close-icon' onClick={this.closeTable}/>
                                        </div>
                                        <div>
                                            <table className="table table-striped table-responsive">
                                                <thead>
                                                <tr>
                                                    <th>{DEFAULT_TEXT.tb_cal_name}</th>
                                                    <th>{DEFAULT_TEXT.tb_cal_type}</th>
                                                    <th>{DEFAULT_TEXT.tb_cal_month}</th>
                                                    <th>{DEFAULT_TEXT.tb_cal_title}</th>
                                                    <th>{DEFAULT_TEXT.tb_cal_desc}</th>
                                                    <th>{DEFAULT_TEXT.tb_cal_actions}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.store.selected_calendar_data.map((calendar, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{calendar.calendar_name}</td>
                                                                <td>{calendar.type}</td>
                                                                {/*<td>{calendar.month.length === 1 ? 0 + calendar.month : calendar.month}</td>*/}
                                                                <td>{calendar.month}</td>
                                                                <td>{calendar.title}</td>
                                                                <td>{calendar.description}</td>
                                                                <td>
                                                                    <div className='calendar-actions'>
                                                                        <EditIcon className='edit-icon-calendar'
                                                                                  onClick={() => this.editCalendar(calendar)}/>
                                                                        <DeleteIcon className='delete-icon-calendar'
                                                                                    onClick={() => this.initDeleteCalendar(calendar)}/>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }/>


                            {show_delete_calendar_alert &&
                            <SweetAlert
                                warning
                                title=''
                                onConfirm={() => this.deleteCalendarConfirmed()}
                                onCancel={() => this.closeDeleteCalendarAlert()}
                                confirmBtnCssClass={classes.button + " " + classes.success}
                                cancelBtnCssClass={classes.button + " " + classes.danger}
                                cancelBtnStyle={{backgroundColor: '#e52d27'}}
                                confirmBtnText={DEFAULT_TEXT.btn_confirm.toUpperCase()}
                                cancelBtnText={DEFAULT_TEXT.btn_cancel.toUpperCase()}
                                showCancel
                            >
                                {DEFAULT_TEXT.delete_row_msg_alert}
                            </SweetAlert>
                            }


                            {error_update_calendar &&
                            <SweetAlert
                                warning
                                title=''
                                onConfirm={() => this.setState({error_update_calendar: false})}
                                confirmBtnCssClass={classes.button + " " + classes.success}
                                cancelBtnStyle={{backgroundColor: '#e52d27'}}
                                confirmBtnText='OK'
                            >
                                {DEFAULT_TEXT.error_update_calendar}
                            </SweetAlert>
                            }
                            {calendar_updated_ok &&
                            <SweetAlert
                                success
                                title=''
                                onConfirm={() => this.setState({calendar_updated_ok: false})}
                                confirmBtnCssClass={classes.button + " " + classes.success}
                                cancelBtnStyle={{backgroundColor: '#e52d27'}}
                                confirmBtnText='OK'
                            >
                                {DEFAULT_TEXT.calendar_updated_ok}
                            </SweetAlert>
                            }
                        </ItemGrid>
                    }

                    {
                        show_delete_calendar_alert &&
                        <SweetAlert
                            warning
                            title=""
                            onConfirm={() => this.deleteCalendarConfirmed()}
                            onCancel={() => this.closeDeleteCalendarAlert()}
                            confirmBtnCssClass={classes.button + " " + classes.success}
                            cancelBtnCssClass={classes.button + " " + classes.danger}
                            cancelBtnStyle={{backgroundColor: '#e52d27'}}
                            confirmBtnText={DEFAULT_TEXT.btn_confirm.toUpperCase()}
                            cancelBtnText={DEFAULT_TEXT.btn_cancel.toUpperCase()}
                            showCancel
                        >{DEFAULT_TEXT.delete_row_msg_alert}
                        </SweetAlert>
                    }

                    {
                        error_calendar_data &&
                        <SweetAlert
                            warning
                            title=""
                            onConfirm={() => this.setState({error_calendar_data: false})}
                            confirmBtnCssClass={classes.button + " " + classes.success}
                            cancelBtnStyle={{backgroundColor: '#e52d27'}}
                            confirmBtnText='OK'
                        > {DEFAULT_TEXT.error_calendar_data}
                        </SweetAlert>
                    }

                    <Dialog classes={{root: classes.center, paper: classes.modal}}
                            open={edit_mode_is_active}
                            onClose={() => this.handleModalClose()}
                            aria-labelledby="classic-modal-slide-title"
                            aria-describedby="classic-modal-slide-description"
                    >

                        <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                            <IconButton
                                className={classes.modalCloseButton}
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                onClick={() => this.handleModalClose()}>
                                <Close className={classes.modalClose}/>
                            </IconButton>
                            <h4 className={classes.modalTitle}>Edit Calendar</h4>
                        </DialogTitle>

                        <DialogContent id="classic-modal-slide-description" className={classes.modalBody}>

                            <div className='modal-form'>
                                <label>{DEFAULT_TEXT.tb_cal_name}</label>
                                <span>{calendar.calendar_name}</span>
                            </div>

                            <div className='modal-form'>
                                <label>{DEFAULT_TEXT.tb_cal_type}</label>
                                <span>{calendar.type}</span>
                            </div>

                            <div className='modal-form'>
                                <label>{DEFAULT_TEXT.tb_cal_title}</label>
                                <input type='text'
                                       onChange={(event) => {
                                           this.setState({
                                               ...this.state,
                                               calendar: {
                                                   ...(this.state.calendar),
                                                   title: event.target.value
                                               },
                                               errors: {
                                                   ...this.state.errors,
                                                   title: false
                                               }
                                           })
                                       }}
                                       className={errors.title ? 'calendar-name-input-error' : 'calendar-name-input'}
                                       defaultValue={calendar.title}/>
                            </div>

                            <div className='modal-form'>
                                <label>{DEFAULT_TEXT.tb_cal_desc}</label>
                                <textarea
                                    className={errors.description ? 'textarea-edit-error' : 'textarea-edit'}
                                    onChange={(event) => {
                                        this.setState({
                                            ...this.state,
                                            calendar: {
                                                ...(this.state.calendar),
                                                description: event.target.value
                                            },
                                            errors: {
                                                ...this.state.errors,
                                                description: false
                                            }
                                        })
                                    }}
                                    defaultValue={calendar.description}/>
                            </div>
                        </DialogContent>

                        <DialogActions className={classes.modalFooterCenter}>
                            <Button onClick={() => this.handleEditCalendarData()} color="success">{DEFAULT_TEXT.save}</Button>
                        </DialogActions>
                    </Dialog>
                </GridContainer>
            </React.Fragment>
        )
    }
}

export default withStyles(notificationsStyle)(CalendarManagement);



// WEBPACK FOOTER //
// ./src/views/Calendar/GestioneCalendar.jsx